export const SIGN_UP_START = 'SIGN_UP_START'
export const SIGN_UP_CANCEL = 'SIGN_UP_CANCEL'
export const SIGN_UP = 'SIGN_UP'
export const START_SUBMITTING = 'START_SUBMITTING'
export const SUCCEED_SUBMITTING = 'SUCCEED_SUBMITTING'
export const FAIL_SUBMITTING = 'FAIL_SUBMITTING'
export const RESET_SIGNUP_ERRORS = 'RESET_SIGNUP_ERRORS'

export const PATH = '/signup'
